import { EventEmitter } from 'events';

import { ClusterProps } from '../../types';
import { EmpathiseColour, NCCluster, NCNode, SearchEntry } from '../../../../src/commonTypes';

export const tutorialEmitter = new EventEmitter();

export const TUTORIAL_EVENT_TYPES = {
	createdNode: 'createdNode',
	openedNodeMenu: 'openedNodeMenu',
	aiEnabled: 'aiEnabled',
	openedProjectVisionPanel: 'openedProjectVisionPanel',
	openedAddToBoardPanel: 'openedAddToBoardPanel',
	addedWordsFromPanel: 'addedWordsFromPanel',
	flowyOnboardingCompleted: 'flowyOnboardingCompleted',
	flowyOnboardingSkipped: 'flowyOnboardingSkipped',
	flowyWelcomeShown: 'flowyWelcomeShown',
	autoSparkStarted: 'autoSparkStarted',
	autoSparkFinished: 'autoSparkFinished',
	bootstrapAutoSparkFinished: 'bootstrapAutoSparkFinished',
	afterAutoSpark: 'afterAutoSpark',

	// Tool selection events
	clickedSpark: 'clickedSpark',
	clickedEmpathise: 'clickedEmpathise',
	clickedGenerate: 'clickedGenerate',
	clickedSynthesise: 'clickedSynthesise',
	synthesiseContextUpdated: 'synthesiseContextUpdated',
	clickedHaikus: 'clickedHaikus',
	clickedAIHaikus: 'clickedAIHaikus',
	clickedGenerateImage: 'clickedGenerateImage',
	clickedGenerateImageResult: 'clickedGenerateImageResult',
	clickedBrainstorm: 'clickedBrainstorm',
	clickedBrainstormResults: 'clickedBrainstormResults',
	clickedSparkResults: 'clickedSparkResults',
	clickedEmpathiseResults: 'clickedEmpathiseResults',
	clickedCommonIdeas: 'clickedCommonIdeas',
	clickedCommonIdeasResults: 'clickedCommonIdeasResults',
	clickedTaglines: 'clickedTaglines',
	clickedGenerateUserPersona: 'clickedGenerateUserPersona',
	clickedGenerateMotivations: 'clickedGenerateMotivations',
	clickedSearch: 'clickedSearch',
	clickedLink: 'clickedLink',
	clickedMerge: 'clickedMerge',
	clickedConnect: 'clickedConnect',
	clickedGeneratePresentation: 'clickedGeneratePresentation',
	lateralSliderMoved: 'lateralSliderMoved',

	// Ideate board
	ideateRecommenderOpened: 'ideateRecommenderOpened',
	ideateRecommenderDismissed: 'ideateRecommenderDismissed',
	positioningOutputSaved: 'positioningOutputSaved',
	positioningFoundationsViewed: 'positioningFoundationsViewed',
	positioningFoundationsConfigurationOpened: 'positioningFoundationsConfigurationOpened',
	clickedPersonalityAnalysis: 'clickedPersonalityAnalysis',
	clickedArchetypeAnalysis: 'clickedArchetypeAnalysis',
	clickedPlotsAnalysis: 'clickedPlotsAnalysis',
	clickedVisualAnalysis: 'clickedVisualAnalysis',
	clickedThemesAnalysis: 'clickedThemesAnalysis',
	clickedRandomAnalysis: 'clickedRandomAnalysis',
	clickedGreekGodsAnalysis: 'clickedGreekGodsAnalysis',
	clickedMotivationsAnalysis: 'clickedMotivationsAnalysis',
	clickedMotivationChallengesAnalysis: 'clickedMotivationChallengesAnalysis',
	clickedMotivationHarmonyAnalysis: 'clickedMotivationHarmonyAnalysis',
	clickedMotivationsStimulationAnalysis: 'clickedMotivationsStimulationAnalysis',
	clickedMotivationsNoveltyAnalysis: 'clickedMotivationsNoveltyAnalysis',
	clickedMotivationsThreatAnalysis: 'clickedMotivationsThreatAnalysis',
	clickedUnlike: 'clickedUnlike',
	
	openedIdeaBox: 'openedIdeaBox',
	openedInvite: 'openedInvite',
	closedInvite: 'closedInvite',
	invitedCollaborator: 'invitedCollaborator',
	selectedNode: 'selectedNode',
	addedTwoNodes: 'addedTwoNodes',
	addedSingleNode: 'addedSingleNode',
	pdfSummaryInsightsAdded: 'pdfSummaryInsightsAdded',
	addedCluster: 'addedCluster',
	likedNode: 'likedNode',
	likedResult: 'likedResult',
	likedCluster: 'likedCluster',
	clickedClusterNode: 'clickedClusterNode',
	mergedNodes: 'mergedNodes',
	connectedNodes: 'connectedNodes',
	updatedLabel: 'updatedLabel',
	afterNewAnalysis: 'afterNewAnalysis',
	openedNotepad: 'openedNotepad',
	addedToNote: 'addedToNote',
	selectingItems: 'selectingItems',
	doneSelectingItems: 'doneSelectingItems',
	synthesiseResult: 'synthesiseResult',
	openedExport: 'openedExport',
	submittedPdfExport: 'submittedPdfExport',
	openedPresentationPreview: 'openedPresentationPreview',
	userPersonasGenerated: 'userPersonasGenerated',
	stakeholderMotivationsGenerated: 'stakeholderMotivationsGenerated',
	linkedInPostGenerated: 'linkedInPostGenerated',
	brandStrategyGenerated: 'brandStrategyGenerated',
	closedTool: 'closedTool',
	
	// Chatbot related events
	disableChatbot: 'disableChatbot',
	enableChatbot: 'enableChatbot',
	chatbotStarted: 'chatbotStarted',
	completedChatbotSequence: 'completedChatbotSequence',
	userDecisionMade: 'userDecisionMade',
	switchBoard: 'switchBoard',
	
	// Generated results from AI tools
	sparkResultsGenerated: 'sparkResultsGenerated',
	empathiseResultsGenerated: 'empathiseResultsGenerated',
	brainstormResultsGenerated: 'brainstormResultsGenerated',
	commonIdeasResultsGenerated: 'commonIdeasResultsGenerated',
	haikuResultsGenerated: 'haikuResultsGenerated',
	aiHaikuResultsGenerated: 'aiHaikuResultsGenerated',
	taglineResultsGenerated: 'taglineResultsGenerated',
	storyResultsGenerated: 'storyResultsGenerated',
	characterResultsGenerated: 'characterResultsGenerated',
	brandColoursResultsGenerated: 'brandColoursResultsGenerated',
	brandToneResultsGenerated: 'brandToneResultsGenerated',
	searchResultsGenerated: 'searchResultsGenerated',
	personaResultsGenerated: 'personaResultsGenerated',
	imageInspireGenerated: 'imageInspireGenerated',
	videoInspireGenerated: 'videoInspireGenerated',
	imageSynthesiseGenerated: 'imageSynthesiseGenerated',
	audiencesGenerated: 'audiencesGenerated',
};

export const userCreatedNode = (node: NCNode) => {
	setTimeout(() => {
		tutorialEmitter.emit('createdNode', { node });
	}, 400);
};

export const openedNodeMenu = (node: NCNode) => {
	tutorialEmitter.emit('openedNodeMenu', { node });
};

export const aiEnabled = () => {
	tutorialEmitter.emit('aiEnabled');
};

export const clickedSpark = (node: NCNode) => {
	tutorialEmitter.emit('clickedSpark', { node });
};

export const clickedEmpathise = (node: NCNode) => {
	tutorialEmitter.emit('clickedEmpathise', { node });
};

export const clickedGenerate = (node: NCNode) => {
	tutorialEmitter.emit('clickedGenerate', { node });
};

export const clickedSynthesise = (node: NCNode) => {
	tutorialEmitter.emit('clickedSynthesise', { node });
};

export const synthesiseContextUpdated = () => {
	tutorialEmitter.emit(TUTORIAL_EVENT_TYPES.synthesiseContextUpdated, {});
};

export const clickedHaikus = () => {
	tutorialEmitter.emit('clickedHaikus', {});
};

export const clickedGenerateUserPersona = () => {
	tutorialEmitter.emit('clickedGenerateUserPersona', {});
};

export const clickedGenerateImage = () => {
	tutorialEmitter.emit('clickedGenerateImage', {});
};

export const clickedGenerateVideo = () => {
	tutorialEmitter.emit('clickedGenerateVideo', {});
};

export const clickedGenerateImageResult = () => {
	tutorialEmitter.emit('clickedGenerateImageResult', {});
};

export const clickedGenerateVideoResult = () => {
	tutorialEmitter.emit('clickedGenerateVideoResult', {});
};

export const clickedBrainstorm = () => {
	tutorialEmitter.emit('clickedBrainstorm', {});
};

export const clickedBrainstormResults = (selectedNodes: Array<NCNode>) => {
	tutorialEmitter.emit('clickedBrainstormResults', { selectedNodes });
};

export const clickedSparkResults = (selectedPhrase: string) => {
	tutorialEmitter.emit('clickedSparkResults', { selectedPhrase });
};

export const clickedEmpathiseResults = (selectedWord: string) => {
	tutorialEmitter.emit('clickedEmpathiseResults', { selectedWord });
};

export const clickedCommonIdeas = () => {
	tutorialEmitter.emit('clickedCommonIdeas', {});
};

export const clickedCommonIdeasResults = () => {
	tutorialEmitter.emit('clickedCommonIdeasResults', {});
};

export const clickedSearch = (node: NCNode) => {
	tutorialEmitter.emit('clickedSearch', { node });
};

export const clickedLink = (node: NCNode) => {
	tutorialEmitter.emit('clickedLink', { node });
};

export const clickedMerge = (node: NCNode) => {
	tutorialEmitter.emit('clickedMerge', { node });
};

export const clickedConnect = (node: NCNode) => {
	tutorialEmitter.emit('clickedConnect', { node });
};

export const openedIdeaBox = () => {
	tutorialEmitter.emit('openedIdeaBox', {});
};

export const openedInvite = () => {
	tutorialEmitter.emit('openedInvite', {});
};

export const closedInvite = () => {
	tutorialEmitter.emit('closedInvite', {});
};

export const invitedCollaborator = () => {
	tutorialEmitter.emit('invitedCollaborator', {});
};

export const selectedNode = (node: NCNode) => {
	tutorialEmitter.emit('selectedNode', { node });
};

export const mergedNodes = (node: NCNode) => {
	tutorialEmitter.emit('mergedNodes', { node });
};

export const connectedNodes = (node: NCNode) => {
	tutorialEmitter.emit('connectedNodes', { node });
};

export const addedTwoNodes = (firstNode: NCNode, secondNode: NCNode) => {
	setTimeout(() => {
		tutorialEmitter.emit('addedTwoNodes', { firstNode, secondNode });
	}, 400);
};

export const addedSingleNode = (node: NCNode) => {
	setTimeout(() => {
		tutorialEmitter.emit('addedSingleNode', { node });
	}, 400);
};

export const pdfSummaryInsightsAdded = (
	analysisId: string,
	title: string,
	suppressStatus = false
) => {
	setTimeout(() => {
		tutorialEmitter.emit('pdfSummaryInsightsAdded', { analysisId, title, suppressStatus });
	}, 500);
};

export const addedCluster = (cluster: NCCluster, props: ClusterProps) => {
	setTimeout(() => {
		tutorialEmitter.emit('addedCluster', { cluster, props });
	}, 50);
};

export const likedNode = (node: NCNode, liked: boolean) => {
	tutorialEmitter.emit('likedNode', { node, liked });
};

export const likedResult = (
	type?: import('../../../../src/commonTypes').LikedItem['type'],
	liked?: boolean,
	url?: string | null,
	text?: string | null,
	title?: string | null,
	topics?: string[] | null
) => {
	tutorialEmitter.emit('likedResult', {
		type: type || null,
		liked: Boolean(liked),
		// `url` lets the backend identify which result was hearted (used by the
		// `research_related_work` block to count unique saves). Optional so
		// non-URL-bearing call sites still work unchanged.
		url: typeof url === 'string' && url ? url : null,
		text: typeof text === 'string' && text ? text : null,
		title: typeof title === 'string' && title ? title : null,
		topics: Array.isArray(topics) ? topics.filter((topic) => typeof topic === 'string') : [],
	});
};

export const positioningOutputSaved = (
	type?: import('../../../../src/commonTypes').LikedItem['type'],
	output?: { id?: string; title?: string }
) => {
	tutorialEmitter.emit(TUTORIAL_EVENT_TYPES.positioningOutputSaved, {
		type: type || null,
		outputId: output?.id || null,
		title: output?.title || null,
		board: 'ideate',
	});
};

export const positioningFoundationsViewed = (title?: string, outputId?: string) => {
	tutorialEmitter.emit(TUTORIAL_EVENT_TYPES.positioningFoundationsViewed, {
		title: title || null,
		outputId: outputId || null,
		board: 'ideate',
	});
};

export const positioningFoundationsConfigurationOpened = (title?: string, outputId?: string) => {
	tutorialEmitter.emit(TUTORIAL_EVENT_TYPES.positioningFoundationsConfigurationOpened, {
		title: title || null,
		outputId: outputId || null,
		board: 'ideate',
	});
};

export const likedCluster = (cluster: NCCluster) => {
	tutorialEmitter.emit('likedCluster', { cluster });
};

/**
 * Fires when the user activates (selects) a node inside the ideate graph.
 * The node may be a cluster center (no `parent`) or one of the child nodes
 * around a center (carries `parent: { uid, label }`). We also include the
 * cluster (group) label and the active analysis key so the chatbot can
 * tailor its follow-up suggestion.
 */
export const clickedClusterNode = (
	node: NCNode,
	context: { clusterLabel?: string | null; analysisKey?: string | null }
) => {
	tutorialEmitter.emit('clickedClusterNode', {
		node,
		clusterLabel: context.clusterLabel || null,
		analysisKey: context.analysisKey || null,
	});
};

export const openedProjectVisionPanel = () => {
	tutorialEmitter.emit('openedProjectVisionPanel', {});
};

export const openedAddToBoardPanel = () => {
	tutorialEmitter.emit('openedAddToBoardPanel', {});
};

export const addedWordsFromPanel = (nodes: Array<NCNode>) => {
	tutorialEmitter.emit('addedWordsFromPanel', { nodes });
};

export const flowyOnboardingCompleted = (payload: {
	input?: string;
	vision?: string;
	summary?: string;
	selectedText?: string;
	centralTitle?: string;
	useCase?: string;
	templateId?: string;
	seeds?: Array<{ label: string; lens: string }>;
}) => {
	tutorialEmitter.emit(TUTORIAL_EVENT_TYPES.flowyOnboardingCompleted, payload);
};

export const flowyOnboardingSkipped = () => {
	tutorialEmitter.emit(TUTORIAL_EVENT_TYPES.flowyOnboardingSkipped, {});
};

export const flowyWelcomeShown = () => {
	tutorialEmitter.emit(TUTORIAL_EVENT_TYPES.flowyWelcomeShown, {});
};

export const autoSparkStarted = () => {
	tutorialEmitter.emit(TUTORIAL_EVENT_TYPES.autoSparkStarted, {});
};

export const autoSparkFinished = () => {
	tutorialEmitter.emit(TUTORIAL_EVENT_TYPES.autoSparkFinished, {});
};

export const bootstrapAutoSparkFinished = () => {
	tutorialEmitter.emit(TUTORIAL_EVENT_TYPES.bootstrapAutoSparkFinished, {});
};

export const afterAutoSpark = (nodes: Array<NCNode>) => {
	tutorialEmitter.emit('afterAutoSpark', { nodes });
};

export const updatedLabel = (node: NCNode) => {
	tutorialEmitter.emit('updatedLabel', { node });
};

export const loadedNewAnalysis = (analysisKey: string) => {
	tutorialEmitter.emit('afterNewAnalysis', { analysisKey: analysisKey });
};

export const ideateRecommenderDismissed = (
	reason: 'closed' | 'started',
	context: { insight?: string | null; analyses?: string[] } = {}
) => {
	tutorialEmitter.emit(TUTORIAL_EVENT_TYPES.ideateRecommenderDismissed, {
		reason,
		insight: context.insight || null,
		analyses: context.analyses || [],
	});
};

export const openedNotepad = () => {
	tutorialEmitter.emit('openedNotepad', {});
};

export const openedExport = () => {
	tutorialEmitter.emit('openedExport', {});
};

export const submittedPdfExport = (pages: string[]) => {
	tutorialEmitter.emit('submittedPdfExport', { pages });
};

export const openedPresentationPreview = () => {
	tutorialEmitter.emit('openedPresentationPreview', {});
};

export const addedToNote = (node: NCNode) => {
	tutorialEmitter.emit('addedToNote', { node });
};

export const selectingItems = () => {
	tutorialEmitter.emit('selectingItems', {});
};

export const doneSelectingItems = () => {
	tutorialEmitter.emit('doneSelectingItems', {});
};

export const synthesiseResult = () => {
	tutorialEmitter.emit('synthesiseResult', {});
};

export const sparkResultsGenerated = (phrases: string[]) => {
	tutorialEmitter.emit('sparkResultsGenerated', { phrases });
};

export const empathiseResultsGenerated = (suggestions: Array<{ color: EmpathiseColour; values: string }>) => {
	tutorialEmitter.emit('empathiseResultsGenerated', { suggestions });
};

export const brainstormResultsGenerated = (results: Array<{ snippet: string, title: string }>) => {
	tutorialEmitter.emit(TUTORIAL_EVENT_TYPES.brainstormResultsGenerated, { results });
}

export const commonIdeasResultsGenerated = (results: Array<{ snippet: string, title: string }>) => {
	tutorialEmitter.emit(TUTORIAL_EVENT_TYPES.commonIdeasResultsGenerated, { results });
}
export const clickedGenerateMotivations = () => {
	tutorialEmitter.emit(TUTORIAL_EVENT_TYPES.clickedGenerateMotivations, {});
}

export function personaGenerated(results: { snippet: string; title: string; }[]) {
	tutorialEmitter.emit(TUTORIAL_EVENT_TYPES.personaResultsGenerated, {results})
}

export function motivationsGenerated(results: { snippet: string; title: string; }[]) {
	tutorialEmitter.emit(TUTORIAL_EVENT_TYPES.stakeholderMotivationsGenerated, {results})
}

export function clickedGeneratePresentation() {
	tutorialEmitter.emit(TUTORIAL_EVENT_TYPES.clickedGeneratePresentation, {});
}

export function lateralSliderMoved(value: number) {
	tutorialEmitter.emit(TUTORIAL_EVENT_TYPES.lateralSliderMoved, {value});
}


export function closedTool(id: string) {
	tutorialEmitter.emit(TUTORIAL_EVENT_TYPES.closedTool, {id});
}

export function disableChatbot() {
	tutorialEmitter.emit(TUTORIAL_EVENT_TYPES.disableChatbot, {});
}

export function enableChatbot() {
	tutorialEmitter.emit(TUTORIAL_EVENT_TYPES.enableChatbot, {});
}
export function aiHaikusGenerated(results: { snippet: string; title: string; }[]) {
	tutorialEmitter.emit(TUTORIAL_EVENT_TYPES.aiHaikuResultsGenerated, {results});
}

export function haikusGenerated(results: { snippet: string; title: string; }[]) {
	tutorialEmitter.emit(TUTORIAL_EVENT_TYPES.haikuResultsGenerated, {results});
}

export function imageInspireGenerated(results: { snippet: string; title: string; }[]) {
	tutorialEmitter.emit(TUTORIAL_EVENT_TYPES.imageInspireGenerated, {results});
}

export function videoInspireGenerated(results: { snippet: string; title: string; }[]) {
	tutorialEmitter.emit(TUTORIAL_EVENT_TYPES.videoInspireGenerated, {results});
}

export function imageSynthesiseGenerated(results: { snippet: string; title: string; }[]) {
	tutorialEmitter.emit(TUTORIAL_EVENT_TYPES.imageSynthesiseGenerated, {results});
}

export function taglinesGenerated(results: { snippet: string; title: string; }[]) {
	tutorialEmitter.emit(TUTORIAL_EVENT_TYPES.taglineResultsGenerated, {results});
}

export function storiesGenerated(results: { snippet: string; title: string; }[]) {
	tutorialEmitter.emit(TUTORIAL_EVENT_TYPES.storyResultsGenerated, {results});
}

export function charactersGenerated(results: { snippet: string; title: string; }[]) {
	tutorialEmitter.emit(TUTORIAL_EVENT_TYPES.characterResultsGenerated, {results});
}

export function brandColoursGenerated(results: { snippet: string; title: string; }[]) {
	tutorialEmitter.emit(TUTORIAL_EVENT_TYPES.brandColoursResultsGenerated, {results});
}

export function brandToneGenerated(results: { snippet: string; title: string; }[]) {
	tutorialEmitter.emit(TUTORIAL_EVENT_TYPES.brandToneResultsGenerated, {results});
}

export function audiencesGenerated(results: { snippet: string; title: string; }[]) {
	tutorialEmitter.emit(TUTORIAL_EVENT_TYPES.audiencesGenerated, {results});
}

export function searchResultsGenerated(results: Array<SearchEntry>) {
	tutorialEmitter.emit(TUTORIAL_EVENT_TYPES.searchResultsGenerated, {results});
}
